module.exports = () => {
  return {
    numberOfPeople: '',
    occasion: '',
    cateringMenu: null,
    unavailableDeliveryLocation: false
  }
}
